/* eslint-disable */
import Cookies from 'js-cookie'

const TokenKey = 'JLF-ERP-TOKEN'
const UserKey = 'JLF-ERP-USER'
const UserMenu = 'JLF-ERP-MENU'
const LoginKey = 'JLF-ERP-LOGIN'
const CompanyIdKey = 'JLF-ERP-COMPANY-ID'
const BudgetIdKey = 'JLF-ERP-BUDGET-ID'
const BudgetGroupIdKey = 'JLF-ERP-BUDGET-GROUP-ID'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}
export function getLogin() {
  return Cookies.get(LoginKey)
}
export function getCompanyId() {
  return Cookies.get(CompanyIdKey)
}
export function getBudgetId() {
  return Cookies.get(BudgetIdKey)
}
export function getBudgetGroupId() {
  return Cookies.get(BudgetGroupIdKey)
}
export function getMenu() {
  return Cookies.get(UserMenu)
}

export function setLogin(isLogin) {
  return Cookies.set(LoginKey, isLogin)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: 30
  })
}

export function setUser(user) {
  return Cookies.set(UserKey, user, {
    expires: 30
  })
}
export function setCompanyId(companyId) {
  return Cookies.set(CompanyIdKey, companyId, {
    expires: 30
  })
}
export function setQuotationTemplateId(quotationTemplateId) {
  return Cookies.set(CompanyIdKey, quotationTemplateId, {
    expires: 30
  })
}
export function setBudgetId(budgetId) {
  return Cookies.set(BudgetIdKey, budgetId, {
    expires: 30
  })
}

export function setBudgetGroupId(budgetGroupId) {
  return Cookies.set(BudgetGroupIdKey, budgetGroupId, {
    expires: 30
  })
}

export function setMenu(menu) {
  return Cookies.set(UserMenu, menu, {
    expires: 30
  })
}

export function removeUserInfo() {
  Cookies.remove(TokenKey)
  Cookies.remove(UserMenu)
  Cookies.remove(CompanyIdKey)
  return Cookies.remove(UserKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js